import { Component, OnInit, Inject, ChangeDetectionStrategy } from "@angular/core";
import { ModalOverlayRef } from "../../class/modal-overlay-ref";
import { DIALOG_R_DATA } from "../../injector/dialog-data.token";
import { CustomEntityService } from "../../services/customEntity.service";
import { SearchResultObject } from "../../models/searchResultObject.model";

import { trackById, trackByIndex } from "src/app/shared/utils/track-by.util";
@Component({
  standalone: false,
    selector: "app-global-search",
    templateUrl: "./global-search.component.html",
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrls: ["./global-search.component.scss"],
})
export class GlobalSearchComponent implements OnInit {
    searchText: any;
    searchResults: any = {};
    searchResultsArr = [];
    searchIcons: any = {};
    searchResultsCount = 0;
    loading = false;

    constructor(
        public dialogRef: ModalOverlayRef,
        @Inject(DIALOG_R_DATA) public data: any,
        private customEntityService: CustomEntityService,
    ) {}

    ngOnInit(): void {}

    search() {
        this.loading = true;
        this.searchResultsCount = 0;
        this.searchResults = {};
        this.searchIcons = {};
        if (this.searchText && this.searchText.length >= 3) {
            this.customEntityService.search(this.searchText).subscribe(
                (endPoints) => {
                    this.loading = false;
                    const searchResults = endPoints as SearchResultObject[];
                    if (searchResults && searchResults.length > 0) {
                        searchResults.forEach((item) => {
                            if (!this.searchResults[item.customObjectName]) {
                                this.searchResults[item.customObjectName] = [];
                                this.searchIcons[item.customObjectName] = [];
                            }
                            const hasElement = this.searchResults[
                                item.customObjectName
                            ].find((oldItem) => oldItem["id"] === item.id);

                            if (!hasElement) {
                                this.searchResults[item.customObjectName].push(
                                    item,
                                );
                                this.searchResultsArr.push(item);
                                this.searchResultsCount += 1;
                            }

                            const hasElement2 = this.searchIcons[
                                item.customObjectName
                            ].find((oldItem) => oldItem["icon"] === item.icon);

                            if (!hasElement2) {
                                this.searchIcons[item.customObjectName].push(
                                    item.icon,
                                );
                            }
                        });
                    }
                },
                (error) => {
                    this.loading = false;
                },
            );
        }
    }

    close() {
        this.dialogRef.close();
    }

    closeAndFlush() {
        const newData = {
            searchedText: this.searchText,
            searchResults: this.searchResultsArr,
        };
        this.dialogRef.closeD(newData);
    }

    selectAndFlush(item: any) {
        this.searchText = item.name;
        const newData = {
            searchedText: this.searchText,
            searchResults: [item],
        };
        this.dialogRef.closeD(newData);
    }

    createNewEndPoint() {
        const newData = {
            searchedText: this.searchText,
            searchResults: [],
        };
        this.dialogRef.closeD(newData);
    }

    public trackById = trackById;
    public trackByIndex = trackByIndex;
}
